import { decode } from 'jsonwebtoken';
import { API_ENDPOINT } from './api';

const expiryBufferSeconds = 60;
const tokenKey = 'authorization-token';

function verifyToken(token: string | null) {
  if (token === null) return false;

  const decodedToken = decode(token);
  if (decodedToken === null || typeof decodedToken !== 'object') return false;

  const { exp } = decodedToken;
  if (Date.now() >= (exp - expiryBufferSeconds) * 1000) return false;

  return true;
}

export const verifyAuth = async () => {
  const currentJWT = localStorage.getItem(tokenKey);
  const tokenValid = verifyToken(currentJWT);

  if (tokenValid) return currentJWT;

  const response = await fetch(`${API_ENDPOINT}/auth`, {
    method: 'GET',
  });
  const { payload: newToken } = await response.json();
  localStorage.setItem(tokenKey, newToken);
  return newToken;
};
